<script lang="ts" setup>
import { RouterLink } from 'vue-router'
import { ApiUrls } from '../../types/base'

defineProps<{
  to: string
  text: string
  missingPermissions?: ApiUrls<any>['permissions']
}>()
</script>

<template>
  <!-- <RouterLink v-if="!missingPermissions || missingPermissions.length === 0" :to="to"> -->
  <RouterLink :to="to">
    <div
      class="nav-item group flex items-center gap-2 xl:gap-2 py-0.5 bg-none w-full text-secondaryBlack text-sm pl-2 xl:pl-4 pr-4 hover:font-semibold transition-all"
    >
      <div
        class="icon p-2 bg-none rounded-full group-hover:text-white group-hover:bg-primary transition-all group-hover:scale-110"
      >
        <slot />
      </div>
      <span class="xl:flex hidden">{{ text }}</span>
    </div>
  </RouterLink>
  <!-- <InvalidPermissionsTooltip v-else :missingPermissions="missingPermissions">
    <span class="cursor-not-allowed opacity-60 relative">
      <div
        class="nav-item group flex items-center gap-2 xl:gap-4 py-2 bg-none w-full text-secondaryBlack text-base pl-2 xl:pl-4 pr-4 hover:bg-red-400 hover:text-white transition-all"
      >
        <div
          class="nav-circle w-[5px] h-[5px] mr-[3px] xl:w-[5px] xl:h-[5px] xl:mr-[5px] shrink-0 bg-red-800 group-hover:bg-none rounded-full"
        ></div>
        <slot />
        <span class="xl:flex hidden">{{ text }}</span>
      </div>
    </span>
  </InvalidPermissionsTooltip> -->
</template>

<style scoped>
.router-link-active .icon {
  @apply bg-primaryBlue text-white;
}
.router-link-active span {
  @apply font-semibold;
}
</style>
